import {
	sys_status_config
} from '@/api/activiti'
export default {
	install(Vue) {
		sys_status_config().then(res => {
			Vue.prototype.newold = res.data.filePathName
		})
		//物品状态
		Vue.prototype.statusMap2 = {
			'1': '在用',
			'2': '准用',
			'3': '待修',
			'4': '维修',
			'5': '检定',
			'7': '外借',
			'8': '停用',
			'9': '退货',
		};
		Vue.prototype.statusMap6 = {
			'1': '在用',
			'2': '准用',
			'3': '待修',
			'4': '维修',
			'5': '检定',
			'6': '报废',
			'7': '外借',
			'8': '停用',
			'9': '退货',
			'10': '库存'
		};
		Vue.prototype.carStatus = {
			'1': '完好',
			'2': '其他',
		}
		Vue.prototype.statusMap3 = {
			'1': '在用',
			'2': '准用',
			'3': '待修',
			'4': '维修',
			'5': '检定',
			'6': '报废',
			'7': '外借',
			'8': '停用',
			'9': '退货',
		};
		Vue.prototype.DefKeyMap = [{
				label: '业务费申请',
				value: 'businessMoney',
			},
			{
				label: '领用申请',
				value: 'claim',
			},
			{
				label: '请假申请',
				value: 'leave',
			}, {
				label: '付款申请',
				value: 'payment',
			}, {
				label: '采购申请',
				value: 'purchase',
			}, {
				label: '报销申请',
				value: 'reimburse',
			}, {
				label: '评审/服务费申请',
				value: 'review',
			}, {
				label: '报废出库',
				value: 'scrapped',
			}
		];
		Vue.prototype.affiliated = [{
				label: '云管家平台',
				value: '1',
				name: '刘静'
			},
			{
				label: '报价系统',
				value: '2',
				name: '袁仁宝'
			},
			{
				label: '环境公卫运营系统',
				value: '3',
				name: '刘俊'
			}, {
				label: '安联云盘',
				value: '4',
				name: '张旦利'
			}, {
				label: '检评系统',
				value: '5',
				name: '李新'
			}, {
				label: '评价系统',
				value: '6',
				name: '刘俊'
			}, {
				label: 'UV贴身管家',
				value: '7',
				name: '张豪'
			}, {
				label: '信息化运营平台',
				value: '8',
				name: '刘俊'
			}
		];
		// Vue.prototype.statusMap = map
		Vue.prototype.delFlagMap = {
			'0': '正常',
			'1': '取消',
		};
		Vue.prototype.instrumentMap = {
			'0': '否',
			'1': '是',
		};
		Vue.prototype.carMap = {
			'0': '公车',
			'1': '私车',
		};
		Vue.prototype.carMap2 = {
			'0': '公车',
			'1': '私车',
			'2': '租车',
			'3': '私车公用'
		};
		Vue.prototype.carStatusMap = {
			'1': '在用',
			'2': '预约',
			'3': '空闲',
		};
		Vue.prototype.carColors = {
			1: 'red',
			2: '#ffc53d',
			3: 'green',
		}
		Vue.prototype.typesMap = {
			'1': '评审费',
			'2': '服务费',
			'3': '其他费用',
		};
		Vue.prototype.paymentMap = {
			'1': '对公（有发票）',
			'2': '对私（无发票）',
			'3': '其他',
		};
		Vue.prototype.payMap = {
			'1': '微信',
			'2': '支付宝',
			'3': '银行转账',
			'4': '现金',
		};
		Vue.prototype.labelledMap = {
			'0': '未打印标签',
			'1': '已打印标签',
		};
		Vue.prototype.imgMap = {
			'0': '未上传图片',
			'1': '已上传图片',
		};
		Vue.prototype.pyapi_url = 'https://coa.anliantest.com/oaProxyApi/proxyPython/file/download?path='
		// Vue.prototype.api_url = 'http://192.168.0.204:9527/file/file/download_static?path='
		Vue.prototype.api_url = process.env.NODE_ENV === 'development' ?
			'http://192.168.0.204:9527/file/file/download_static?path=' :
			'https://coa.anliantest.com/oaProxyApi/proxyJava/file/file/download_static?path=';
		//物品类型
		Vue.prototype.goodsType = [{
				label: '办公用品',
				value: 46,
			},
			{
				label: '办公耗材',
				value: 47,
			},
			{
				label: '办公设备',
				value: 48,
			}, {
				label: '检测耗材',
				value: 49,
			}, {
				label: '体检耗材',
				value: 83,
			}, {
				label: '计量类耗材',
				value: 50,
			}, {
				label: '标准物质',
				value: 51,
			}, {
				label: '劳保用品',
				value: 52,
			}, {
				label: '仪器设备',
				value: 53,
			}, {
				label: '员工福利',
				value: 63,
			}, {
				label: '招待物品',
				value: 64,
			},
			{
				label: '其他',
				value: 65,
			}
		]
		//
		Vue.prototype.typesType = [{
				label: '差旅费',
				value: 1,
			},
			{
				label: '招待费',
				value: 2,
			},
			{
				label: '设备采购',
				value: 3,
			}, {
				label: '耗材采购',
				value: 4,
			}, {
				label: '办公用品',
				value: 5,
			}, {
				label: '活动经费',
				value: 6,
			}, {
				label: '其他费用',
				value: 7,
			}, {
				label: '房租/水电费',
				value: 8,
			}
		]
		Vue.prototype.driverType = [{
				label: '不需要',
				value: 0,
			},
			{
				label: '需要',
				value: 1,
			},
		]
		//物品类型
		Vue.prototype.goodsTypeObj = {
			46: '办公用品',
			47: '办公耗材',
			48: '办公设备',
			49: '检测耗材',
			50: '计量类耗材',
			51: '标准物质',
			52: '劳保用品',
			53: '仪器设备',
			63: '员工福利',
			64: '招待物品',
			65: '其他',
			83: '体检耗材',
		}

		//列表状态
		Vue.prototype.status_apply = {
			'1': {
				txt: '审批中',
				color: '#FAAD14',
			},
			'2': {
				txt: '结束',
				color: '#999999',
			},
			'3': {
				txt: '撤销',
				color: 'red',
			},
			'4': {
				txt: '中止',
				color: '#222222',
			}
		}
		//列表状态
		Vue.prototype.status_apply_result = { 
			'1': {
				txt: '处理中',
				color: '#FAAD14',
				id: 1
			},
			'2': {
				txt: '结束',
				color: '#999999',
				id: 2
			},
			'3': {
				txt: '撤销',
				color: 'red',
				id: 3
			},
			'4': {
				txt: '中止',
				color: '#222222',
				id: 4
			}
		}
		//列表结果
		Vue.prototype.result_apply = {
			'1': {
				txt: '审批中',
				color: '#FAAD14',
			},
			'2': {
				txt: '通过',
				color: '#52C41A',
			},
			'3': {
				txt: '驳回',
				color: '#FF4D4F',
			},
			'4': {
				txt: '撤销',
				color: '#999999',
			},
			'6': {
				txt: '中止',
				color: '#222222',
			}
		}

		Vue.prototype.colors = {
			1: '#389E0D',
			2: '#135200',
			3: '#FFA940',
			4: '#FA8C16',
			5: '#1890FF',
			6: '#9B9B9B',
			7: '#003A8C',
			8: '#CF1322',
			9: '#555555',
			10: '#AD48D9'
		}
		Vue.prototype.Wacolors = {
			1: '#F59A23',
			2: '#C888F4',
			7: '#69B839',
		}
		Vue.prototype.colors2 = {
			0: '#d4380d',
			1: '#ff7a45',
			2: '#ff9c6e',
			3: '#d46b08',
			4: '#fa8c16',
			5: '#ffa940',
			6: '#d48806',
			7: '#faad14',
			8: '#ffc53d',
			9: '#d4b106',
			10: '#fadb14',
			11: '#ffec3d',
			12: '#7cb305',
			13: '#a0d911',
			14: '#bae637',
			15: '#389e0d',
			16: '#52c41a',
			17: '#73d13d',
			18: '#08979c',
			19: '#13c2c2',
			20: '#36cfc9',
			21: '#096dd9',
			22: '#1890ff',
			23: '#40a9ff',
			24: '#1d39c4',
			25: '#2f54eb',
			26: '#597ef7',
			27: '#531dab',
			28: '#722ed1',
			29: '#9254de',
		}
		//采购状态
		Vue.prototype.applyStatus = {
			0: '等待采购',
			1: '已采购',
			2: '等待验收',
			3: '已验收',
			4: '已入库'
		}
		//采购审批状态
		Vue.prototype.applyExamineStatus = {
			0: '已通过',
			1: '审批中',
		}
		//月份
		Vue.prototype.month = {
			0: '一月',
			1: '二月',
			2: '三月',
			3: '四月',
			4: '五月',
			5: '六月',
			6: '七月',
			7: '八月',
			8: '九月',
			9: '十月',
			10: '十一月',
			11: '十二月',
		}
		Vue.prototype.rnr = {
			0: '未读',
			1: '已读',
		}
		Vue.prototype.receive = {
			0: '待领用',
			1: '已领用',
			2: '已驳回',
		}
		//付款申请类别
		Vue.prototype.payMentTypes = {
			1: '试剂或耗材',
			2: '办公用品及办公耗材',
			3: '警示标牌或广告宣传材料',
			4: '仪器检定或仪器维修',
			5: '仪器及办公设备',
			6: '培训费',
			7: '标书费或招标代理费',
			8: '房租或水电费',
			9: '业务退款',
			10: '业务分包费',
			11: '备用金',
			12: '投资款',
			13: '其他'
		}
		// 课程标签颜色
		Vue.prototype.courseColors=(index,type)=>{
			var obj={
				'1':{color:'#91d5ff',bgColor:'#e6f7ff7a'},
				'2':{color:'#5dc672',bgColor:'#5dc67226'},
				'3':{color:'#d3a959',bgColor:'#d3a95912'},
				'4':{color:'#95bdfb',bgColor:'#95bdfb1c'},
				'5':{color:'#d36007',bgColor:'#d3600714'},
				'6':{color:'#d8d613',bgColor:'#d8d61314'},
				'7':{color:'#ff3232',bgColor:'#ff323212'},
				'8':{color:'#a24cd2',bgColor:'#a24cd214'},
				'9':{color:'#8ed24c',bgColor:'#8ed24c1f'},
				'10':{color:'#9b2237',bgColor:'#9b22370d'},
			}
			if(type=='color'){
				return obj[index].color
			}else{
				return obj[index].bgColor
			}
			
		}
		Vue.prototype.scroll_y = 150
		Vue.prototype.get_file_type = {
			'doc':'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
			'docx':'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
			'png':'application/x-png'
		}

		Vue.prototype.uploadUri = process.env.NODE_ENV === 'development' ? 'http://192.168.0.204:8888' :
			'https://coa.anliantest.com/oaProxyApi/proxyPython';
		Vue.prototype.uploadUriJava = process.env.NODE_ENV === 'development' ? 'http://192.168.0.204:9527' :
			'https://coa.anliantest.com/oaProxyApi/proxyJava';
	}


}
